import { t } from 'i18next';
import { LogoOlist } from 'images';
import { string } from 'prop-types';

import { Box, Breadcrumb } from '@olist/united';

const LeadsHeader = ({ currentStep }) => {
  const steps = [
    {
      key: 'accountCreated',
      name: t`account created`,
    },
    {
      key: 'requirements',
      name: t`requirements`,
    },
    {
      key: 'join',
      name: t`join olist store`,
    },
  ];

  return (
    <>
      <Box display="block" mt={5}>
        <img alt="olist store" src={LogoOlist} width={50} height={20} />
      </Box>
      <Box my={4}>
        <Breadcrumb steps={steps} currentStep={currentStep} />
      </Box>
    </>
  );
};

export default LeadsHeader;

LeadsHeader.propTypes = {
  currentStep: string.isRequired,
};
LeadsHeader.steps = {
  REQUIREMENTS: 'requirements',
};
